import { logPopupError } from "utils/Utils";
import { t } from "i18next";
import API from "apiHelpers";
import { Loader } from "store/actions";
import reduxstore from "store/store";
import C from "Constants";

const fallBackMessage = t("Payby error please contact support");

const createPaymentIntent = async ({
  amountTobePaid,
  selectedStore,
  brand,
  userRefId,
  params,
  DomainType,
  serviceType , 
  queryParams = ''
}) => {
  try {
    reduxstore.dispatch(Loader.togggleCheckoutLoader(true));
    
    const date = new Date();
    const uaeFormatted = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Dubai',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
    
    const isDineIn = serviceType === 'DINE IN';
    // Build the base path
    const successPath = isDineIn
      ? (DomainType === C.TEMPORARAY_DOMAIN 
          ? `/${params.domainName}/dine-in/payment-confirm?${queryParams}`
          : `/dine-in/payment-confirm?${queryParams}`)
      : (DomainType === C.TEMPORARAY_DOMAIN 
          ? `/${params.domainName}/payment-confirm`
          : '/payment-confirm');

    const payload = {
      payByPayload: {
        merchantOrderNo: ("M" +selectedStore._id+ Date.now()).toString().slice(0,64),
        subject: "Order For " + selectedStore?.baseLanguage?.name + " - (" + (brand?.brandName ?? process.env.REACT_APP_COMPANY_NAME)
          + ") - " + uaeFormatted,
        totalAmount: {
          currency: "AED",
          amount: amountTobePaid,
        },
        accessoryContent: {
          operatorId: selectedStore?.brandId,
          storeId: selectedStore._id,
          terminalId: process.env.REACT_APP_COMPANY_NAME,
          merchantName: brand?.brandName,
          storeName: selectedStore?.baseLanguage?.name,
        },
        redirectUrl: `${window.location.origin}${successPath}`,
        notifyUrl: `${process.env.REACT_APP_BASE_API_URL}payment-gateway/payby/payment-intent-webhook`
      },
      metaData: {
        storeId: selectedStore._id,
        brandId: selectedStore?.brandId,
        userRefId:userRefId
      },
    };
    const resp = await API.placeOrderOnPayBy(payload)
    return resp
  } catch (error) {
    logPopupError(error.message || fallBackMessage, true);
    return error;
  } finally {
    reduxstore.dispatch(Loader.togggleCheckoutLoader(false));
  }
};

const verifyPayment = async (payload, hideModal= false) => {
  try {
    reduxstore.dispatch(Loader.togggleCheckoutLoader(true));
    const resp = await API.verifyPayByPayment(payload);
    return resp;
  } catch (error) {
    if(!hideModal){
      logPopupError(error.message || fallBackMessage, true);
    }
    return error;
  } finally {
    reduxstore.dispatch(Loader.togggleCheckoutLoader(false));
  }
};

export {
  createPaymentIntent,
  verifyPayment,
}